<template>
  <div id="all_components">
    <CoverPage
      v-bind:portfolio="portfolio"
    />
    <TableOfContents
      v-bind:renderedPages="renderedPages"
    />
    <approach-to-data></approach-to-data>
    <your-impact-preferences
      v-bind:portfolio="portfolio"
    />
    <PortfolioOverview
      v-bind:portfolio="portfolio"
      v-bind:benchmark="benchmark"
    />
    <!-- <Comparisons></Comparisons>  -->
    <Corporate
      v-bind:portfolio="portfolio"
      v-bind:benchmark="benchmark"
    />
    <MSCI 
      v-bind:portfolio="portfolio"
      v-bind:benchmark="benchmark"
      v-if="this.feature_flags.includes('Feature: MSCI')"
    />
    <Metaphors
      v-bind:portfolio="portfolio"
      v-bind:benchmark="benchmark"
    />
    <ShareholderEngagement
      v-bind:portfolio="portfolio"
    />
    <overall-disclaimers v-bind:portfolio="portfolio"></overall-disclaimers>
    <Holdings
      :portfolio="portfolio"
      :dollarsOrPercentagesChoice="dollarsOrPercentages"
    />
    <BenchmarkHoldings
      v-if="benchmark.name"
      :benchmark="benchmark"
      :dollarsOrPercentagesChoice="dollarsOrPercentages"
    />
    <!-- <MBS></MBS> -->
    <!-- <Sovereign></Sovereign> -->
  </div>
</template>

<script>

  import CoverPage from './CoverPage.vue';
  import TableOfContents from './TableOfContents.vue';
  import Comparisons from './Comparisons.vue';
  import Metaphors from './Metaphors.vue';
  import MBS from './MBS.vue';
  import Sovereign from './Sovereign.vue';
  import Corporate from './Corporate.vue';
  import MSCI from './MSCI.vue';
  import PortfolioOverview from './PortfolioOverview.vue';
  import YourImpactPreferences from './YourImpactPreferences.vue';
  import Holdings from './Holdings.vue';
  import BenchmarkHoldings from './BenchmarkHoldings.vue';
  import ApproachToData from './ApproachToData.vue';
  import OverallDisclaimers from './OverallDisclaimers.vue';
  import ShareholderEngagement from './ShareholderEngagement.vue';

  import eventBus from '@frontend/shared/EventBus.js';
  import { apiFetch } from '../../../api/api';

  export default {
    data () {
      return {
        portfolio: null,
        dollarsOrPercentages: 'dollars', // valid values 'dollars', 'percentages'
        benchmark: null,
        metrics: {
          a: [],
          byId: {},
        },
        renderedPages: {
          // Pages that will always be rendered. Remove if a page becomes
          // toggleable.
          Holdings: true,
          Corporate: true,
          PortfolioOverview: true,
          YourImpactPreferences: true,
          ApproachToData: true,
          TableOfContents: true,
          CoverPage: true,

          // Pages that aren't always rendered
          BenchmarkHoldings: false,
          ShareholderEngagement: false,
          Metaphors: false,
        }
      }
    },
    mounted: function() {
      var self = this;
      eventBus.$on('InstitutionalReport:page-rendered', (pageName) => {
        console.log(`Recv render event from ${pageName}`);
        self.$set(this.renderedPages, pageName, true);
        if (window.parent) {
          window.parent.dispatchEvent(new CustomEvent('report-rendered'));
        }
      });
    },
    created: async function() {
      const bootstrapData = JSON.parse(document.getElementById('js_bootstrap').textContent);
      this.$root.$data.STATIC_ROOT = bootstrapData.static_root;
      this.feature_flags = bootstrapData.feature_flags
      this.portfolio = bootstrapData.portfolio;
      this.benchmark = bootstrapData.benchmark_portfolio || {};
      this.dollarsOrPercentages = bootstrapData.dollarsOrPercentages;

      bootstrapData.metrics.forEach((itm, idx, arr) => {
        this.metrics.a.push(itm);
        this.metrics.byId[itm.id] = itm;
      });

      this.portfolio.screen_sets.forEach((itm, idx, arr) => {
        itm.metrics.forEach((m) => {
          m.details = this.metrics.byId[m.metric_description];
        });
      });

      let id = this.benchmark.id ? `${this.portfolio.id}:${this.benchmark.id}` : this.portfolio.id;
      const currentParams = new URLSearchParams(window.location.search);
      let newParams = {
        comparison: 'relative',
        include_low_coverage: 1,
      };
      const screens = currentParams.get('screens') || bootstrapData.screens;
      if (screens) newParams.impact_factors = screens;
      const benchmark_no_engagement = currentParams.get('benchmark_no_engagement') || bootstrapData.benchmark_no_engagement;
      if (benchmark_no_engagement) newParams.benchmark_no_engagement = benchmark_no_engagement;

      let response = await apiFetch(`/api/v1/portfolios/${id}/report/impact/?${new URLSearchParams(newParams).toString()}`);
      let data = await response.json();
      this.$set(this.portfolio, 'impact_report', data);
      this.portfolio.impact_report.report.metrics.forEach((m) => {
        this.$set(m, 'details', this.metrics.byId[m.impact_factor_id]);
      });

      if(this.feature_flags.includes('Feature: MSCI')) {
        delete(newParams.impact_factors)
        let response2 = await apiFetch(`/api/v1/portfolios/${id}/report/msci/?${new URLSearchParams(newParams).toString()}`);
        let data2 = await response2.json();
        this.$set(this.portfolio, 'msci_report', data2);
        this.portfolio.msci_report.report.metrics.forEach((m) => {
          this.$set(m, 'details', this.metrics.byId[m.impact_factor_id]);
        });
      }
    },
    components: {
      CoverPage, TableOfContents, OverallDisclaimers, Comparisons, Metaphors, MBS, PortfolioOverview, Sovereign, Corporate, MSCI, YourImpactPreferences, Holdings, BenchmarkHoldings, ApproachToData, ShareholderEngagement
    },
    methods: {
      randomize: function() {
        this.interestingNumber = Math.random() * Math.random();
      }
    },
  }
</script>

<style lang="scss">

.page {
  width: 8.5in;
  min-height: 11.5in;
  margin: 1in auto;
  padding: 0.5in;
  border: 1px solid var(--black-95);
  background-color: var(--main-bg-color);
}

#fixed-border {
  display: none;
}

@page {
  size: letter portrait;
  margin: 0.5in 0.5in;
}

@media print {

  .print-no-break {
    break-inside: avoid;
  }

  .page {
    border: none;
    width: 100%;
    min-height: 100%;
    margin: 0;
    padding: 0.25in;
    width: none;
    page-break-before: always;
  }

  body, html {
    margin: 0;
    padding: 0;
  }

  #fixed-border {
    display: block;
    position: fixed;
    border: 1px solid var(--black-95);
    padding: 10px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
</style>
